import { Environment } from '../../../enums';

const API_VERSION = 'api/v2';

export const getLegacyBaseUrl = (environment: Environment, withVersion: boolean = true): string => {
    const versionSuffix = withVersion ? `/${API_VERSION}` : '';
    switch (environment) {
        case Environment.QA2:
        case Environment.QA3: {
            return `https://frontoffice.eu-west-1.dce-${environment}.dicelaboratory.com${versionSuffix}`;
        }
        case Environment.DEV:
        case Environment.QA:
        case Environment.STAGING: {
            return `https://dce-frontoffice-${environment}.imggaming.com${versionSuffix}`;
        }
        default: {
            return `https://dce-frontoffice.imggaming.com${versionSuffix}`;
        }
    }
};
